export default {"src":"/_next/static/media/english_selected.fb03d83d.svg","height":464,"width":464,"blurWidth":0,"blurHeight":0};